/* eslint-disable */
import React, { useEffect, useState } from "react";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { useTranslation } from "../../locale/useTranslation";
import * as API from '../../framework/API/api';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { EditPageHeader } from "../../components/EditPageHeader";
import { ADMARKERS, AUDIOSELECTERS, CAPTIONSELECTORS, CODESPECIFICATION, DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS, ENTITYNAME, LOGEVENT, MODULE } from "../../framework/constant/constant";
import { utility } from "../../framework/utility/utilityProvider";

export const DaiTranscodingForm = ({ onSave, cancelEdit, item }) => {
    const navigate = useNavigate();
    const lang = useTranslation();
    const { SID } = useParams();
    const loc = useLocation();

    const INPUT_FILTER = {
        AUTO: "AUTO",
        FORCE: "FORCE",
        DISABLED: "DISABLED",
    };

    const SCTE35_SOURCE = {
        SEGMENTS: "SEGMENTS",
        MANIFEST: "MANIFEST",
        PASSTHROUGH: "PASSTHROUGH",
    };

    const SERVER_VALIDATION = {
        CHECK_CRYPTOGRAPHY_AND_VALIDATE_NAME: "CHECK_CRYPTOGRAPHY_AND_VALIDATE_NAME",
        CHECK_LICENSE: "CHECK_LICENSE",
        VALIDATE_TOKEN: "VALIDATE_TOKEN",
    };

    const SMPTE2038_DATA_PREFERENCE = {
        IGNORE: "IGNORE",
        EMBED: "EMBED",
        PASSTHROUGH: "PASSTHROUGH",
    };

    const SOURCE_END_BEHAVIOR = {
        CONTINUE: "CONTINUE",
        LOOP: "LOOP",
        STOP: "STOP",
    };

    const CAPTION_LANGUAGE_SETTINGS = {
        OMIT: "OMIT",
        INSERT: "INSERT",
        NONE: "NONE"
    };

    const DIRECTORY_STRUCTURE = {
        SINGLE_DIRECTORY: "SINGLE_DIRECTORY",
        NESTED: "NESTED"
    };

    const DISCONTINUITY_TAGS = {
        INSERT: "INSERT",
        NONE: "NONE"
    };

    const INCOMPLETE_SEGMENT_BEHAVIORS = {
        AUTO: "AUTO",
        RETRY: "RETRY",
        RETRY: "RETRY"
    };

    const INPUT_LOSS_ACTIONS = {
        EMIT_OUTPUT: "EMIT_OUTPUT",
        PAUSE: "PAUSE",
        STOP: "STOP"
    };

    const IVIN_MANIFEST = {
        INCLUDE: "INCLUDE",
        EXCLUDE: "EXCLUDE"
    };

    const IV_SOURCE = {
        FOLLOWS_SEGMENT_NUMBER: "FOLLOWS_SEGMENT_NUMBER",
        MANUAL: "MANUAL"
    };

    const MANIFEST_COMPRESSION = {
        GZIP: "GZIP",
        NONE: "NONE"
    };

    const MANIFEST_DURATION_FORMAT = {
        FLOATING_POINT: "FLOATING_POINT",
        SECONDS: "SECONDS",
        MILLISECONDS: "MILLISECONDS"
    };

    const MODE = {
        LIVE: "LIVE",
        VOD: "VOD"
    };

    const OUTPUT_SELECTION = {
        MANIFESTS_AND_SEGMENTS: "MANIFESTS_AND_SEGMENTS",
        CURRENT_ONLY: "CURRENT_ONLY"
    };

    const PROGRAM_DATETIME = {
        EXCLUDE: "EXCLUDE",
        LOCAL: "LOCAL",
        UTC: "UTC"
    };

    const PROGRAM_DATETIME_CLOCK = {
        INITIALIZE_FROM_OUTPUT_TIMECODE: "INITIALIZE_FROM_OUTPUT_TIMECODE",
        SYSTEM_CLOCK: "SYSTEM_CLOCK"
    }

    const SEGMENTATION_MODE = {
        USE_SEGMENT_DURATION: "USE_SEGMENT_DURATION",
        USE_INPUT_TIMECODES: "USE_INPUT_TIMECODES"
    };

    const TIMED_METADATA_ID3_FRAME = {
        PRIV: "PRIV",
        TXXX: "TXXX"
    };

    const TS_FILE_MODE = {
        SEGMENTED_FILES: "SEGMENTED_FILES",
        SINGLE: "SINGLE"
    };

    const NO_REGIONAL_BLACKOUT_FLAG = {
        FOLLOW: "FOLLOW",
        IGNORE: "IGNORE"
    }

    const SCTE35_SEGMENTATION_SCOPE = {
        SCTE35_ENABLED_OUTPUT_GROUPS: "SCTE35_ENABLED_OUTPUT_GROUPS",
        SEGMENTATION_EVENT_ID: "SEGMENTATION_EVENT_ID"
    }

    const blankDataItem = {
        SID: 0,
        Name: "",
        SegmentLength: 0,
        AdMarkers: [],
        CaptionLanguageMappings: [],
        CaptionLanguageSetting: "",
        ClientCache: "",
        CodecSpecification: {},
        DirectoryStructure: "",
        DiscontinuityTags: "",
        HlsId3SegmentTagging: {},
        IFrameOnlyPlaylists: {},
        IncompleteSegmentBehavior: "",
        IndexNSegments: 0,
        InputLossAction: "",
        IvInManifest: "",
        IvSource: "",
        KeepSegments: 0,
        ManifestCompression: "",
        ManifestDurationFormat: "",
        Mode: "",
        OutputSelection: "",
        ProgramDateTime: "",
        ProgramDateTimeClock: "",
        ProgramDateTimePeriod: 0,
        RedundantManifest: {},
        SegmentationMode: "",
        SegmentsPerSubdirectory: 0,
        StreamInfResolution: "",
        TimedMetadataId3Frame: "",
        TimedMetadataId3Period: 0,
        TsFileMode: "",

        AdAvailOffset: "",
        NoRegionalBlackoutFlag: "",
        WebDeliveryAllowedFlag: "",
        Scte35SegmentationScope: "",

        AudioSelectors: [],
        CaptionSelectors: [],
        DeblockFilter: { _id: "DISABLED", Description: "DISABLED" },
        DenoiseFilter: { _id: "DISABLED", Description: "DISABLED" },
        FilterStrength: 0,
        InputFilter: "AUTO",
        BufferSegments: 0,
        Retries: 0,
        RetryInterval: 0,
        Scte35Source: "",
        ServerValidation: "",
        Smpte2038DataPreference: "",
        SourceEndBehavior: "",
        Archive: false,
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [languages, setLanguages] = useState([]);

    useEffect(() => {
        pageRender();
    }, [item, SID]);

    const pageRender = async () => {
        await loadcombo();

        if (item && item._id) {
            bindItemData(item);
        } else if (SID > 0) {
            await loadEditData();
        } else {
            setDataItem({ ...blankDataItem });
        }
    };

    const bindItemData = (resData) => {
        const output = resData?.OutputConfiguration || {};
        const avail = resData?.AvailConfiguration || {};
        const input = resData?.InputConfiguration || {};
        const netInput = input?.NetworkInputSettings?.HlsInputSettings || {};

        setDataItem({
            ...resData,
            SegmentLength: output?.SegmentLength ?? 0,
            AdMarkers: output?.AdMarkers?.map(desc => ({ _id: desc, Description: desc })) || [],
            CaptionLanguageMappings: output?.CaptionLanguageMappings?.map(desc => ({ _id: desc, Description: desc })) || [],
            CaptionLanguageSetting: output?.CaptionLanguageSetting ? { _id: output.CaptionLanguageSetting, Description: output.CaptionLanguageSetting } : {},
            ClientCache: output?.ClientCache ? { _id: output.ClientCache, Description: output.ClientCache } : {},
            CodecSpecification: output?.CodecSpecification ? { _id: output.CodecSpecification, Description: output.CodecSpecification } : {},
            DirectoryStructure: output?.DirectoryStructure ? { _id: output.DirectoryStructure, Description: output.DirectoryStructure } : {},
            DiscontinuityTags: output?.DiscontinuityTags ? { _id: output.DiscontinuityTags, Description: output.DiscontinuityTags } : {},
            HlsId3SegmentTagging: output?.HlsId3SegmentTagging ? { _id: output.HlsId3SegmentTagging, Description: output.HlsId3SegmentTagging } : {},
            IFrameOnlyPlaylists: output?.IFrameOnlyPlaylists ? { _id: output.IFrameOnlyPlaylists, Description: output.IFrameOnlyPlaylists } : {},
            IncompleteSegmentBehavior: output?.IncompleteSegmentBehavior ? { _id: output.IncompleteSegmentBehavior, Description: output.IncompleteSegmentBehavior } : {},
            IndexNSegments: output?.IndexNSegments ?? 0,
            InputLossAction: output?.InputLossAction ? { _id: output.InputLossAction, Description: output.InputLossAction } : {},
            IvInManifest: output?.IvInManifest ? { _id: output.IvInManifest, Description: output.IvInManifest } : {},
            IvSource: output?.IvSource ? { _id: output.IvSource, Description: output.IvSource } : {},
            KeepSegments: output?.KeepSegments ?? 0,
            ManifestCompression: output?.ManifestCompression ? { _id: output.ManifestCompression, Description: output.ManifestCompression } : {},
            ManifestDurationFormat: output?.ManifestDurationFormat ? { _id: output.ManifestDurationFormat, Description: output.ManifestDurationFormat } : {},
            Mode: output?.Mode ? { _id: output.Mode, Description: output.Mode } : {},
            OutputSelection: output?.OutputSelection ? { _id: output.OutputSelection, Description: output.OutputSelection } : {},
            ProgramDateTime: output?.ProgramDateTime ? { _id: output.ProgramDateTime, Description: output.ProgramDateTime } : {},
            ProgramDateTimeClock: output?.ProgramDateTimeClock ? { _id: output.ProgramDateTimeClock, Description: output.ProgramDateTimeClock } : {},
            ProgramDateTimePeriod: output?.ProgramDateTimePeriod ?? 0,
            RedundantManifest: output?.RedundantManifest ? { _id: output.RedundantManifest, Description: output.RedundantManifest } : {},
            SegmentationMode: output?.SegmentationMode ? { _id: output.SegmentationMode, Description: output.SegmentationMode } : {},
            SegmentsPerSubdirectory: output?.SegmentsPerSubdirectory ?? 0,
            StreamInfResolution: output?.StreamInfResolution ? { _id: output.StreamInfResolution, Description: output.StreamInfResolution } : {},
            TimedMetadataId3Frame: output?.TimedMetadataId3Frame ? { _id: output.TimedMetadataId3Frame, Description: output.TimedMetadataId3Frame } : {},
            TimedMetadataId3Period: output?.TimedMetadataId3Period ?? 0,
            TsFileMode: output?.TsFileMode ? { _id: output.TsFileMode, Description: output.TsFileMode } : {},

            AdAvailOffset: avail?.AvailSettings?.Scte35SpliceInsert?.AdAvailOffset ?? "",
            NoRegionalBlackoutFlag: avail?.AvailSettings?.Scte35SpliceInsert?.NoRegionalBlackoutFlag
                ? { _id: avail.AvailSettings.Scte35SpliceInsert.NoRegionalBlackoutFlag, Description: avail.AvailSettings.Scte35SpliceInsert.NoRegionalBlackoutFlag }
                : {},
            WebDeliveryAllowedFlag: avail?.AvailSettings?.Scte35SpliceInsert?.WebDeliveryAllowedFlag
                ? { _id: avail.AvailSettings.Scte35SpliceInsert.WebDeliveryAllowedFlag, Description: avail.AvailSettings.Scte35SpliceInsert.WebDeliveryAllowedFlag }
                : {},
            Scte35SegmentationScope: avail?.Scte35SegmentationScope
                ? { _id: avail.Scte35SegmentationScope, Description: avail.Scte35SegmentationScope }
                : {},

            AudioSelectors: input?.AudioSelectors?.map((desc) => ({ _id: desc, Description: desc })) || [],
            CaptionSelectors: input?.CaptionSelectors?.map((desc) => ({ _id: desc, Description: desc })) || [],
            DeblockFilter: input?.DeblockFilter
                ? { _id: input.DeblockFilter, Description: input.DeblockFilter }
                : { _id: "DISABLED", Description: "DISABLED" },
            DenoiseFilter: input?.DenoiseFilter
                ? { _id: input.DenoiseFilter, Description: input.DenoiseFilter }
                : { _id: "DISABLED", Description: "DISABLED" },
            FilterStrength: input?.FilterStrength ?? 0,
            InputFilter: input?.InputFilter
                ? { _id: input.InputFilter, Description: input.InputFilter }
                : { _id: "AUTO", Description: "AUTO" },
            BufferSegments: netInput?.BufferSegments ?? 0,
            Retries: netInput?.Retries ?? 0,
            RetryInterval: netInput?.RetryInterval ?? 0,
            Scte35Source: netInput?.Scte35Source
                ? { _id: netInput.Scte35Source, Description: netInput.Scte35Source }
                : {},
            ServerValidation: input?.NetworkInputSettings?.ServerValidation
                ? { _id: input.NetworkInputSettings.ServerValidation, Description: input.NetworkInputSettings.ServerValidation }
                : {},
            Smpte2038DataPreference: input?.Smpte2038DataPreference
                ? { _id: input.Smpte2038DataPreference, Description: input.Smpte2038DataPreference }
                : {},
            SourceEndBehavior: input?.SourceEndBehavior
                ? { _id: input.SourceEndBehavior, Description: input.SourceEndBehavior }
                : {},

            Archive: resData?.Archive ?? false,
        });
    };

    const loadEditData = async () => {
        try {
            const res = await API.getEntity(ENTITYNAME.DAI_TRANSCODINGS, parseInt(SID));
            if (res.success && res.data) {
                bindItemData(res.data);
            } else {
                toast.error(
                    <div>
                        <strong>INVALID</strong>
                        <div style={{ fontSize: '13px' }}>{res.message || "Failed to load configuration."}</div>
                    </div>,
                    { position: toast.POSITION.TOP_RIGHT }
                );
            }
        } catch (err) {
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '13px' }}>An unexpected error occurred while loading configuration.</div>
                </div>,
                { position: toast.POSITION.TOP_RIGHT }
            );
        }
    };
    const onChange = (e, nameProp) => {
        if (e?.target) {
            const { name, value, checked } = e.target;
            if (name === "Archive") {
                setDataItem({ ...dataItem, Archive: checked });
            }
            else {
                setDataItem({ ...dataItem, [name]: value });
            }
        } else if (Array.isArray(e)) {
            if (!nameProp) return;
            setDataItem({ ...dataItem, [nameProp]: e });
        } else if (typeof e === "object" && nameProp) {
            setDataItem({ ...dataItem, [nameProp]: e });
        }
    };

    const loadcombo = async () => {
        const languagesResult = await API.getDataLookup(ENTITYNAME.Language, {
            sort: { Description: 1 },
        });
        setLanguages(languagesResult.data);
    };

    const isValid = () => {
        if (!dataItem.Name || dataItem.Name.trim() === "") {
            toast.error(`${lang.please_enter_name_error_message}`, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return false;
        }
        return true;
    };

    const handleSubmit = async () => {
        if (!isValid()) return;

        const localData = {
            _id: dataItem?._id,
            SID: dataItem?.SID ?? 0,
            Name: dataItem?.Name ?? "",
            Archive: dataItem?.Archive ?? false,
            OutputConfiguration: {
                SegmentLength: parseInt(dataItem?.SegmentLength || 0),
                AdMarkers:
                    dataItem?.AdMarkers?.length > 0
                        ? dataItem.AdMarkers.map((x) => x.Description)
                        : [],
                CaptionLanguageMappings:
                    dataItem?.CaptionLanguageMappings?.length > 0
                        ? dataItem.CaptionLanguageMappings.map((x) => x.Description)
                        : [],
                CaptionLanguageSetting: dataItem.CaptionLanguageSetting?.Description ?? {},
                ClientCache: dataItem.ClientCache?.Description ?? {},
                CodecSpecification: dataItem.CodecSpecification?.Description ?? {},
                DirectoryStructure: dataItem.DirectoryStructure?.Description ?? {},
                DiscontinuityTags: dataItem.DiscontinuityTags?.Description ?? {},
                HlsId3SegmentTagging: dataItem.HlsId3SegmentTagging?.Description ?? {},
                IFrameOnlyPlaylists: dataItem.IFrameOnlyPlaylists?.Description ?? {},
                IncompleteSegmentBehavior: dataItem.IncompleteSegmentBehavior?.Description ?? {},
                IndexNSegments: parseInt(dataItem.IndexNSegments || 0),
                InputLossAction: dataItem.InputLossAction?.Description ?? {},
                IvInManifest: dataItem.IvInManifest?.Description ?? {},
                IvSource: dataItem.IvSource?.Description ?? {},
                KeepSegments: parseInt(dataItem.KeepSegments || 0),
                ManifestCompression: dataItem.ManifestCompression?.Description ?? {},
                ManifestDurationFormat: dataItem.ManifestDurationFormat?.Description ?? {},
                Mode: dataItem.Mode?.Description ?? {},
                OutputSelection: dataItem.OutputSelection?.Description ?? {},
                ProgramDateTime: dataItem.ProgramDateTime?.Description ?? {},
                ProgramDateTimeClock: dataItem.ProgramDateTimeClock?.Description ?? {},
                ProgramDateTimePeriod: parseInt(dataItem.ProgramDateTimePeriod || 0),
                RedundantManifest: dataItem.RedundantManifest?.Description ?? {},
                SegmentationMode: dataItem.SegmentationMode?.Description ?? {},
                SegmentsPerSubdirectory: parseInt(dataItem.SegmentsPerSubdirectory || 0),
                StreamInfResolution: dataItem.StreamInfResolution?.Description ?? {},
                TimedMetadataId3Frame: dataItem.TimedMetadataId3Frame?.Description ?? {},
                TimedMetadataId3Period: parseInt(dataItem.TimedMetadataId3Period || 0),
                TsFileMode: dataItem.TsFileMode?.Description ?? {},
            },
            AvailConfiguration: {
                AvailSettings: {
                    Scte35SpliceInsert: {
                        AdAvailOffset: parseInt(dataItem.AdAvailOffset) || 0,
                        NoRegionalBlackoutFlag: dataItem.NoRegionalBlackoutFlag?.Description || "",
                        WebDeliveryAllowedFlag: dataItem.WebDeliveryAllowedFlag?.Description || "",
                    },
                },
                Scte35SegmentationScope: dataItem.Scte35SegmentationScope?.Description || "",
            },
            InputConfiguration: {
                AudioSelectors: dataItem.AudioSelectors?.length > 0
                    ? dataItem.AudioSelectors.map((x) => x.Description)
                    : [],
                CaptionSelectors: dataItem.CaptionSelectors?.length > 0
                    ? dataItem.CaptionSelectors.map((x) => x.Description)
                    : [],
                DeblockFilter: dataItem.DeblockFilter?.Description || "DISABLED",
                DenoiseFilter: dataItem.DenoiseFilter?.Description || "DISABLED",
                FilterStrength: parseInt(dataItem.FilterStrength) || 0,
                InputFilter: dataItem.InputFilter?.Description || "AUTO",
                NetworkInputSettings: {
                    HlsInputSettings: {
                        BufferSegments: parseInt(dataItem.BufferSegments) || 0,
                        Retries: parseInt(dataItem.Retries) || 0,
                        RetryInterval: parseInt(dataItem.RetryInterval) || 0,
                        Scte35Source: dataItem.Scte35Source?.Description || "",
                    },
                    ServerValidation: dataItem.ServerValidation?.Description || "",
                },
                Smpte2038DataPreference: dataItem.Smpte2038DataPreference?.Description || "",
                SourceEndBehavior: dataItem.SourceEndBehavior?.Description || "",
            }
        };

        console.log(localData);

        const res = await API.saveData(ENTITYNAME.DAI_TRANSCODINGS, localData);
        if (res.success) {
            localData._id = res?.data?._id;
            let logData = { event: res.message === "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.DAI_CONFIGURATION, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.DAI_TRANSCODINGS);
            toast.success(lang.successfully_saved_message, { position: toast.POSITION.TOP_RIGHT });
            onSave && onSave(localData);
            onClose();
        } else {
            toast.error(res.message, { position: toast.POSITION.TOP_RIGHT });
        }
    };

    const borderStyle = {
        border: "1px solid #ced4da",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#FAFAFA",
    };

    const onClose = () => {
        if (cancelEdit) {
            cancelEdit();
        } else if (loc.state && loc.state.prevPath) {
            navigate(loc.state.prevPath);
        } else {
            navigate(-1);
        }
    };

    return (
        <>
            <div className="row mb-5">
                <div className="col-12">
                    <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={onClose} showTitle={false} />
                    <div className="row mb-2">
                        <div className="col-3">
                            <label htmlFor="">{lang.name_label} *</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                name="Name"
                                value={dataItem.Name}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-3" style={{ marginTop: "27px" }}>
                            <input
                                type="checkbox"
                                name={"Archive"}
                                checked={dataItem.Archive}
                                onChange={onChange}
                            />
                            <label className="pl-2" htmlFor="TabView">
                                {lang.archive}
                            </label>
                        </div>
                    </div>
                    <span>{lang.input_configuration_label}</span>
                    <div className="border form-group p-2 with-3d-effect" style={borderStyle}>
                        <div className="row mb-2">
                            <div className="col-3">
                                <label htmlFor="">{lang.audio_selectors_label}</label>
                                <MultiSelect
                                    data={Object.keys(AUDIOSELECTERS).map((obj) => ({ _id: AUDIOSELECTERS[obj], Description: obj }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.AudioSelectors}
                                    onChange={(e) => onChange(e.value, "AudioSelectors")}
                                    name={"AudioSelectors"}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.caption_selectors_label}</label>
                                <MultiSelect
                                    data={Object.keys(CAPTIONSELECTORS).map((obj) => ({ _id: CAPTIONSELECTORS[obj], Description: obj }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.CaptionSelectors}
                                    onChange={(e) => onChange(e.value, "CaptionSelectors")}
                                    name={"CaptionSelectors"}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.filter_strength_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="FilterStrength"
                                    value={dataItem.FilterStrength}
                                    onChange={onChange}
                                    min={0}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.input_filter_label}</label>
                                <DropDownList
                                    data={Object.keys(INPUT_FILTER).map((obj) => ({
                                        _id: INPUT_FILTER[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.InputFilter}
                                    onChange={(e) => onChange(e.value, "InputFilter")}
                                    name={"InputFilter"}
                                />
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.buffer_segments_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="BufferSegments"
                                    value={dataItem.BufferSegments}
                                    onChange={onChange}
                                    min={0}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.retries_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="Retries"
                                    value={dataItem.Retries}
                                    onChange={onChange}
                                    min={0}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.retry_interval_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="RetryInterval"
                                    value={dataItem.RetryInterval}
                                    onChange={onChange}
                                    min={0}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.scte35_source_label}</label>
                                <DropDownList
                                    data={Object.keys(SCTE35_SOURCE).map((obj) => ({
                                        _id: SCTE35_SOURCE[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Scte35Source}
                                    onChange={(e) => onChange(e.value, "Scte35Source")}
                                    name={"Scte35Source"}
                                />
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.server_validation_label}</label>
                                <DropDownList
                                    data={Object.keys(SERVER_VALIDATION).map((obj) => ({
                                        _id: SERVER_VALIDATION[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.ServerValidation}
                                    onChange={(e) => onChange(e.value, "ServerValidation")}
                                    name={"ServerValidation"}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.smpte2038_data_preference_label}</label>
                                <DropDownList
                                    data={Object.keys(SMPTE2038_DATA_PREFERENCE).map((obj) => ({
                                        _id: SMPTE2038_DATA_PREFERENCE[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Smpte2038DataPreference}
                                    onChange={(e) => onChange(e.value, "Smpte2038DataPreference")}
                                    name={"Smpte2038DataPreference"}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.source_end_behavior_label}</label>
                                <DropDownList
                                    data={Object.keys(SOURCE_END_BEHAVIOR).map((obj) => ({
                                        _id: SOURCE_END_BEHAVIOR[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.SourceEndBehavior}
                                    onChange={(e) => onChange(e.value, "SourceEndBehavior")}
                                    name={"SourceEndBehavior"}
                                />
                            </div>
                            <div className="col-3">
                                <label className="pl-2" htmlFor="TabView">
                                    {lang.deblock_filter_label}
                                </label>
                                <DropDownList
                                    data={Object.keys(DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS).map((obj) => ({
                                        _id: DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.DeblockFilter}
                                    onChange={(e) => onChange(e.value, "DeblockFilter")}
                                    name={"DeblockFilter"}
                                />
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-3">
                                <label className="pl-2" htmlFor="TabView">
                                    {lang.denoise_filter_label}
                                </label>
                                <DropDownList
                                    data={Object.keys(DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS).map((obj) => ({
                                        _id: DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.DenoiseFilter}
                                    onChange={(e) => onChange(e.value, "DenoiseFilter")}
                                    name={"DenoiseFilter"}
                                />
                            </div>
                        </div>
                    </div>
                    <span>{lang.output_configuration_setting_label}</span>
                    <div className="border p-2 form-group with-3d-effect" style={borderStyle}>
                        <div className="row">
                            <div className="col-3">
                                <label htmlFor="">{lang.segment_length_label}</label>
                                <input
                                    className="form-control form-control-sm"
                                    type="number"
                                    name="SegmentLength"
                                    onChange={onChange}
                                    value={dataItem.SegmentLength}
                                    min={0}
                                />
                            </div>
                            <div className="col-3">
                                <label>{lang.admarkers_label}</label>
                                <MultiSelect
                                    data={Object.keys(ADMARKERS).map((key) => ({
                                        _id: ADMARKERS[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.AdMarkers}
                                    onChange={(e) => onChange(e.value, "AdMarkers")}
                                    name="AdMarkers"
                                />
                            </div>
                            <div className="col-3">
                                <label>{lang.caption_language_mappings_label}</label>
                                <MultiSelect
                                    style={{ backgroundColor: "white" }}
                                    data={languages}
                                    name="CaptionLanguageMappings"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.CaptionLanguageMappings}
                                    onChange={(e) => onChange(e.value, "CaptionLanguageMappings")}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="">{lang.caption_language_setting_label} </label>
                                <DropDownList
                                    data={Object.keys(CAPTION_LANGUAGE_SETTINGS).map((key) => ({
                                        _id: CAPTION_LANGUAGE_SETTINGS[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.CaptionLanguageSetting}
                                    onChange={(e) => onChange(e.value, "CaptionLanguageSetting")}
                                    name="CaptionLanguageSetting"
                                />
                            </div>
                        </div>
                        <div className="row mt-1 mb-2">
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.client_cache}</label>
                                <DropDownList
                                    data={Object.keys(DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS).map((key) => ({
                                        _id: DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.ClientCache}
                                    onChange={(e) => onChange(e.value, "ClientCache")}
                                    name="ClientCache"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.codec_specification_label}</label>
                                <DropDownList
                                    data={Object.keys(CODESPECIFICATION).map((obj) => ({
                                        _id: CODESPECIFICATION[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.CodecSpecification}
                                    onChange={(e) => onChange(e.value, "CodecSpecification")}
                                    name={"CodecSpecification"}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.directory_structure_label}</label>
                                <DropDownList
                                    data={Object.keys(DIRECTORY_STRUCTURE).map((key) => ({
                                        _id: DIRECTORY_STRUCTURE[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.DirectoryStructure}
                                    onChange={(e) => onChange(e.value, "DirectoryStructure")}
                                    name="DirectoryStructure"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.discontinuity_tags_label}</label>
                                <DropDownList
                                    data={Object.keys(DISCONTINUITY_TAGS).map((key) => ({
                                        _id: DISCONTINUITY_TAGS[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.DiscontinuityTags}
                                    onChange={(e) => onChange(e.value, "DiscontinuityTags")}
                                    name="DiscontinuityTags"
                                />
                            </div>
                        </div>
                        <div className="row mt-1 mb-2">
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.hlsId3_segment_tagging_label}</label>
                                <DropDownList
                                    data={Object.keys(DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS).map((obj) => ({
                                        _id: DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.HlsId3SegmentTagging}
                                    onChange={(e) => onChange(e.value, "HlsId3SegmentTagging")}
                                    name={"HlsId3SegmentTagging"}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.iframe_only_playlists_label}</label>
                                <DropDownList
                                    data={Object.keys(DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS).map((obj) => ({
                                        _id: DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.IFrameOnlyPlaylists}
                                    onChange={(e) => onChange(e.value, "IFrameOnlyPlaylists")}
                                    name={"IFrameOnlyPlaylists"}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.incomplete_segment_behavior_label}</label>
                                <DropDownList
                                    data={Object.keys(INCOMPLETE_SEGMENT_BEHAVIORS).map((key) => ({
                                        _id: INCOMPLETE_SEGMENT_BEHAVIORS[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.IncompleteSegmentBehavior}
                                    onChange={(e) => onChange(e.value, "IncompleteSegmentBehavior")}
                                    name="IncompleteSegmentBehavior"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.indexn_segments_label}</label>
                                <input
                                    className="form-control form-control-sm"
                                    type="number"
                                    name="IndexNSegments"
                                    onChange={onChange}
                                    value={dataItem.IndexNSegments}
                                    min={0}
                                />
                            </div>
                        </div>
                        <div className="row mt-1 mb-2">
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.input_loss_action_label}</label>
                                <DropDownList
                                    data={Object.keys(INPUT_LOSS_ACTIONS).map((key) => ({
                                        _id: INPUT_LOSS_ACTIONS[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.InputLossAction}
                                    onChange={(e) => onChange(e.value, "InputLossAction")}
                                    name="InputLossAction"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.ivin_manifest_label}</label>
                                <DropDownList
                                    data={Object.keys(IVIN_MANIFEST).map((key) => ({
                                        _id: IVIN_MANIFEST[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.IvInManifest}
                                    onChange={(e) => onChange(e.value, "IvInManifest")}
                                    name="IvInManifest"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.iv_source_label}</label>
                                <DropDownList
                                    data={Object.keys(IV_SOURCE).map((key) => ({
                                        _id: IV_SOURCE[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.IvSource}
                                    onChange={(e) => onChange(e.value, "IvSource")}
                                    name="IvSource"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.keep_segments_label}</label>
                                <input
                                    className="form-control form-control-sm"
                                    type="number"
                                    name="KeepSegments"
                                    onChange={onChange}
                                    value={dataItem.KeepSegments}
                                    min={0}
                                />
                            </div>
                        </div>
                        <div className="row mt-1 mb-2">
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.manifest_compression_label}</label>
                                <DropDownList
                                    data={Object.keys(MANIFEST_COMPRESSION).map((key) => ({
                                        _id: MANIFEST_COMPRESSION[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.ManifestCompression}
                                    onChange={(e) => onChange(e.value, "ManifestCompression")}
                                    name="ManifestCompression"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.manifest_duration_format_label}</label>
                                <DropDownList
                                    data={Object.keys(MANIFEST_DURATION_FORMAT).map((key) => ({
                                        _id: MANIFEST_DURATION_FORMAT[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.ManifestDurationFormat}
                                    onChange={(e) => onChange(e.value, "ManifestDurationFormat")}
                                    name="ManifestDurationFormat"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.matchMediaode_label}</label>
                                <DropDownList
                                    data={Object.keys(MODE).map((key) => ({
                                        _id: MODE[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Mode}
                                    onChange={(e) => onChange(e.value, "Mode")}
                                    name="Mode"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.output_selection_label}</label>
                                <DropDownList
                                    data={Object.keys(OUTPUT_SELECTION).map((key) => ({
                                        _id: OUTPUT_SELECTION[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.OutputSelection}
                                    onChange={(e) => onChange(e.value, "OutputSelection")}
                                    name="OutputSelection"
                                />
                            </div>
                        </div>
                        <div className="row mt-1 mb-2">
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.program_datetime_label}</label>
                                <DropDownList
                                    data={Object.keys(PROGRAM_DATETIME).map((key) => ({
                                        _id: PROGRAM_DATETIME[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.ProgramDateTime}
                                    onChange={(e) => onChange(e.value, "ProgramDateTime")}
                                    name="ProgramDateTime"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.program_datetimeclock_label}</label>
                                <DropDownList
                                    data={Object.keys(PROGRAM_DATETIME_CLOCK).map((key) => ({
                                        _id: PROGRAM_DATETIME_CLOCK[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.ProgramDateTimeClock}
                                    onChange={(e) => onChange(e.value, "ProgramDateTimeClock")}
                                    name="ProgramDateTimeClock"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.program_datetime_period_label}</label>
                                <input
                                    className="form-control form-control-sm"
                                    type="number"
                                    name="ProgramDateTimePeriod"
                                    onChange={onChange}
                                    value={dataItem.ProgramDateTimePeriod}
                                    min={0}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.redundantManifest_label}</label>
                                <DropDownList
                                    data={Object.keys(DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS).map((obj) => ({
                                        _id: DAI_OUTPUTS_SCENE_CHANGE_DETECT_OPTIONS[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.RedundantManifest}
                                    onChange={(e) => onChange(e.value, "RedundantManifest")}
                                    name={"RedundantManifest"}
                                />
                            </div>
                        </div>
                        <div className="row mt-1 mb-2">
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.segmentation_mode_label}</label>
                                <DropDownList
                                    data={Object.keys(SEGMENTATION_MODE).map((key) => ({
                                        _id: SEGMENTATION_MODE[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.SegmentationMode}
                                    onChange={(e) => onChange(e.value, "SegmentationMode")}
                                    name="SegmentationMode"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.segmentsPer_subdirectory_label}</label>
                                <input
                                    className="form-control form-control-sm"
                                    type="number"
                                    name="SegmentsPerSubdirectory"
                                    onChange={onChange}
                                    value={dataItem.SegmentsPerSubdirectory}
                                    min={0}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.satisfiestreaminf_resolution_label}</label>
                                <DropDownList
                                    data={Object.keys(IVIN_MANIFEST).map((key) => ({
                                        _id: IVIN_MANIFEST[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.StreamInfResolution}
                                    onChange={(e) => onChange(e.value, "StreamInfResolution")}
                                    name="StreamInfResolution"
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.timed_metadataid3frame_label}</label>
                                <DropDownList
                                    data={Object.keys(TIMED_METADATA_ID3_FRAME).map((key) => ({
                                        _id: TIMED_METADATA_ID3_FRAME[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.TimedMetadataId3Frame}
                                    onChange={(e) => onChange(e.value, "TimedMetadataId3Frame")}
                                    name="TimedMetadataId3Frame"
                                />
                            </div>
                        </div>
                        <div className="row mt-1 mb-2">
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.timed_metadataid3period_label}</label>
                                <input
                                    className="form-control form-control-sm"
                                    type="number"
                                    name="TimedMetadataId3Period"
                                    onChange={onChange}
                                    value={dataItem.TimedMetadataId3Period}
                                    min={0}
                                />
                            </div>
                            <div className="col-3">
                                <label htmlFor="TabView">{lang.tsFile_mode_label}</label>
                                <DropDownList
                                    data={Object.keys(TS_FILE_MODE).map((key) => ({
                                        _id: TS_FILE_MODE[key],
                                        Description: key,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.TsFileMode}
                                    onChange={(e) => onChange(e.value, "TsFileMode")}
                                    name="TsFileMode"
                                />
                            </div>
                        </div>
                    </div>
                    <span>{lang.avail_configuration_label}</span>
                    <div className="border form-group p-2 with-3d-effect" style={borderStyle}>
                        <div className="row mb-2">
                            <div className="col-3">
                                <label>{lang.add_avail_offset_label}</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="AdAvailOffset"
                                    value={dataItem.AdAvailOffset || ""}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-3">
                                <label>{lang.no_regional_blackout_flag_label}</label>
                                <DropDownList
                                    data={Object.keys(NO_REGIONAL_BLACKOUT_FLAG).map((obj) => ({
                                        _id: NO_REGIONAL_BLACKOUT_FLAG[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.NoRegionalBlackoutFlag}
                                    onChange={(e) => onChange(e.value, "NoRegionalBlackoutFlag")}
                                    name={"NoRegionalBlackoutFlag"}
                                />
                            </div>
                            <div className="col-3">
                                <label>{lang.web_delivery_allowed_flag_label}</label>
                                <DropDownList
                                    data={Object.keys(NO_REGIONAL_BLACKOUT_FLAG).map((obj) => ({
                                        _id: NO_REGIONAL_BLACKOUT_FLAG[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.WebDeliveryAllowedFlag}
                                    onChange={(e) => onChange(e.value, "WebDeliveryAllowedFlag")}
                                    name={"WebDeliveryAllowedFlag"}
                                />
                            </div>
                            <div className="col-3">
                                <label>{lang.scte35_segmentation_scope_label}</label>
                                <DropDownList
                                    data={Object.keys(SCTE35_SEGMENTATION_SCOPE).map((obj) => ({
                                        _id: SCTE35_SEGMENTATION_SCOPE[obj],
                                        Description: obj,
                                    }))}
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Scte35SegmentationScope}
                                    onChange={(e) => onChange(e.value, "Scte35SegmentationScope")}
                                    name={"Scte35SegmentationScope"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

